import { FontState, ThemeState, DirectionState, LanguageState } from '../components/configurations/types';

// declare global {
//     interface Window {
//         config: any;
//     }
// }

// window.config = window.config || {};

const { API_URL, BASE, FIDS } = (window as any).config;

let DEFAULT_DIRECTION: DirectionState = 'rtl';
let DEFAULT_FONT: FontState = 'homa';
let DEFAULT_THEME: ThemeState = 'theme1';
let DEFAULT_LANGUAGE: LanguageState = 'fa';
let DEFAULT_PAGE_SIZE: number = 10;
let DEFAULT_LIST_REFREASH_INTERVAL: number = 30000;
let DEFAULT_CALENDAR_VIEW: string = 'day';
let DEFAULT_HIDDEN_COLUMNS: any = { FlightRequestList: ['departureTime', 'entranceTime'], FlightReport: [], RplList: [] };
let DEFAULT_COLUMNS_ORDER: any = { FlightRequestList: [], FlightReport: [], FlightRequestReport: [], RplList: [] };
let DEFAULT_SELECTED_FILTERS: any = { FlightRequestList: {}, FlightReport: {}, calendar: {}, RplList: {} };
let WEBSOCKET_PREFIX: string = '/user/queue';
let API_PREFIX: string = 'api/v1';
export const PERSIAN_ALPHABETs = [" ", "آ", "ا", "ب", "پ", "ت", "ث", "ج", "چ", "ح", "خ", "د", "ذ", "ر", "ز", "ژ", "س", "ش", "ص", "ض", "ط", "ظ", "ع", "غ", "ف", "ق", "ک", "گ", "ل", "م", "ن", "و", "ه", "ی", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

export const configuration = {
    BASE_URL: API_URL || `http://localhost:9999`,
    BASE_API_IMAGE: `${API_URL}/api/v1/image/` || `http://localhost:9999/api/v1/image/`,
    BASE_API_FILE: `${API_URL}/api/v1/file/` || `http://localhost:9999/api/v1/file/`,
    FIDS_URL: FIDS || 'http://localhost:4444',
    DEFAULT_LANGUAGE: DEFAULT_LANGUAGE,
    DEFAULT_DIRECTION: DEFAULT_DIRECTION,
    DEFAULT_FONT: DEFAULT_FONT,
    DEFAULT_THEME: DEFAULT_THEME,
    DEFAULT_PAGE_SIZE: DEFAULT_PAGE_SIZE,
    DEFAULT_LIST_REFREASH_INTERVAL: DEFAULT_LIST_REFREASH_INTERVAL,
    DEFAULT_HIDDEN_COLUMNS: DEFAULT_HIDDEN_COLUMNS,
    DEFAULT_COLUMNS_ORDER: DEFAULT_COLUMNS_ORDER,
    DEFAULT_SELECTED_FILTERS: DEFAULT_SELECTED_FILTERS,
    DEFAULT_CALENDAR_VIEW: DEFAULT_CALENDAR_VIEW
};

export const TYPES = {
    rplType: 'rpl',
    extraType: 'extra',
    cancellationType: 'cancellation',
    reEstablishType: 'reEstablish',
    timeChangeType: 'timeChange',
    other: 'other'
}

export const STATUSES = {
    monitoringConfirmedStatus: 'monitoringConfirmedStatus',
    requestCreatedStatus: 'requestCreatedStatus',
    requestOffer: 'requestOffer',
    requestApprovedBySupervisor: 'requestApprovedBySupervisor',
    requestApprovedByAdmin: 'requestApprovedByAdmin',
    requestApprovedBySuperadmin: 'requestApprovedBySuperadmin',
    requestRejectedBySupervisor: 'requestRejectedBySupervisor',
    requestRejectedByAdmin: 'requestRejectedByAdmin',
    requestedRejectedBySuperadmin: 'requestedRejectedBySuperadmin',
    airlineFinalRejection: 'airlineFinalRejection',
    success: 'success',
}

export const GROUP_NAMES = {
    airlineGroupName: 'airline',
    adminGroupName: 'admin',
    supervisorGroupName: 'supervisor',
    superadminGroupName: 'superadmin',
}

export const ERRORS = {
    errorMessageExitFlight: 'تداخل با ساعت اذان. اقامه نماز در مقصد یا مبدا امکان پذیر نیست',
    errorMessageBlockTime: 'تداخل با ساعت اذان. اقامه نماز در مقصد یا مبدا امکان پذیر نیست',
    minuteCapacity: 'ظرفیت در ساعت 00:00 تکمیل است',
    samePathCapacity: 'تکمیل ظرفیت پروازهای هم مسیری',
    sameRouteCapacity: 'تکمیل ظرفیت پروازهای هم روتی',
    rplOnlyTimeRange: 'این نوع پرواز در این بازه ساعتی مجاز نیست',
    notInAllowedFlightNumberRange: 'شماره پرواز در بازه مجاز نیست',
    wrongDate: 'تاریخ درخواستی اشتباه است',
    airlinesNightStayShare: 'ظرفیت شب‌خوابی در این روز تکمیل است',
    airlineCityShare: 'سهمیه ایرلاین برای شهر مقصد تمام شده‌است',
    airlineHourlyShare: 'سهمیه پرواز ایرلاین در این بازه یک ساعته تمام شده‌است',
    hourCapacity: 'ظرفیت در این بازه زمانی تکمیل است',
    duplicateFlightNumber: 'شماره پرواز در این بازه برای این روز(ها) قبلا ثبت شده ‌است',
    cityNotFound: 'شهر مورد نظر یافت نشد',
    goingFlightTimeOverlap: 'تداخل زمانی با پرواز برگشت بعد از تغییر ساعت به دلیل تداخل اذان صبح',
    comingFlightTimeOverlap: 'تداخل زمانی با پرواز رفت بعد از تغییر ساعت به دلیل تداخل اذان صبح',
    goingFlightTimeOverlap_timechange: 'تداخل زمانی با پرواز برگشت',
    comingFlightTimeOverlap_timechange: 'تداخل زمانی با پرواز رفت',
    beforeRplStartDateNotAllowed: 'ثبت درخواست فصلی قبل از تاریخ شروع برنامه فصلی امکان پذیر نیست',
    afterRplEndDateNotAllowed: 'ثبت درخواست فصلی بعد از تاریخ پایان برنامه فصلی امکان پذیر نیست'
}

export const PAGES = {
    //BASE: 'http://localhost',
    BASE: BASE || 'http://192.168.1.143',
    FIDS: FIDS || 'http://localhost:4444',
    REPORT: '/flight-report',
    NEW_REQUEST: '/new-request',
    CONTINUE_REQUEST: '/new-request/:id',
    REQUEST_DETAILS: '/request/:id',
    REQUEST_OFFER: '/request-offer/:id',
    REQUESTS_LIST: '/requests',
    CALENDAR: '/calendar',
    CONFIGURATION: '/configuration',
    SYSTEM_RULES: '/system/rules',
    RPL_CONSTRAINTS: '/system/rpl-constraints',
    TERMINALS: '/system/terminals',
    TIME_SHARE: '/system/time-share',
    CITY_SHARE: '/system/city-share',
    NIGHT_STAY_SHARE: '/system/night-stay-share',
    REQUEST_CANCEL: '/cancel/:id',
    REQUEST_REESTABLISH: '/reestablish/:id',
    TIME_CHANGE: '/time-change/:id',
    FLIGHT_REQUEST_REPORT: '/flight-request-report',
    FLIGHT_REQUEST_REPORT_LIST: '/request-reports',
    RPL_LIST: '/rpls-list',
    USERS: '/security/users'
};

export const ROUTES = {
    WEBSOCKET_PREFIX: WEBSOCKET_PREFIX,
    API_PREFIX: API_PREFIX,
    AUTH: {
        LOGIN: '/auth/login',
        LOGOUT: '/auth/logout',
        RESET_MFA: '/auth/reset-mfa'
    },
    AIRLINE: {
        GET_AIRLINE: '/airline/get-airline',
        GET_AIRLINES: '/airline/get-airlines',
        UPDATE_AIRLINE: '/airline/update-airline'
    },
    PROPERTIES: {
        APP_INFO: "/properties/get-app-info"
    },
    SECURITY: {
        SECURITY_PROFILE: '/users/user-profile',
        USER_CONFIG: '/set-user-config',
        IAM_LISTS: "/security/iam-policies"
    },
    AGENT: {
        PARTY_LIST: '/agent/party-list',
        UPDATE_AGENT_PROFILE: '/users/update-user-profile',
    },
    CITY: {
        GET_CITY_LIST: '/cities/get-cities',
    },
    FIDS: {
        CONFIRM_MONITORING_NUMBER: '/fids/monitoring-number',
        GET_FLIGHT_INFO: '/fids/get-flight-info',
        UPDATE_MONITORING_FILE: '/fids/update-monitoring-file'
    },
    FLIGHT_TYPES: {
        GET_FLIGHT_TYPES: '/types/get-flight-types',
    },
    FLIGHT_REQUEST: {
        REVIEW: '/flights/review-flight-request',
        SUBMIT: "/flights/submit-flight-request",
        CREATE: '/flights/flight-request',
        GET_FLIGHT_REQUESTS_LIST: '/flights/flight-requests',
        GET_FLIGHT_REQUEST: '/flights/flight-request',
        APPROVE_FLIGHT_REQUEST: '/flights/approve-request',
        SAVE_FLIGHT_REQUEST: '/flights/save-request',
        REJECT_FLIGHT_REQUEST: '/flights/reject-request',
        AIRLINE_REJECT_FLIGHT_REQUEST: '/flights/reject-request-airline',
        OFFER_FLIGHT_REQUEST: '/flights/offer-request',
        REVIEW_OFFER: '/flights/review-offer',
        SUBMIT_OFFER: '/flights/submit-offer',
        CONFIRM_OFFER_REQUEST: '/flights/confirm-offer',
        AIRLINE_REQUEST_AFTER_REJECTION: '/flights/re-request',
        REESTABLISH_REQUEST: '/flights/reestablish-request',
        REESTABLISH_FLIGHTS: '/flights/reestablish-flights',
        REESTABLISH_REQUEST_AFTER_REJECTION: '/flights/reestablish-flights-rerequest',
        TIME_CHANGE_REQUEST: '/flights/time-change-request',
        TIME_CHANGE_FLIGHTS: '/flights/time-change',
        TIME_CHANGE_REQUEST_AFTER_REJECTION: '/flights/time-change-rerequest',
        REMOVE_FLIGHT_REQUESTS: '/flights/remove-flight-requests'
    },
    FLIGHT: {
        GET_FLIGHTS_LIST: '/flights/get-flights',
        DOWNLOAD_FLIGHTS: '/flights/download-flights',
        GET_FLIGHTS_BY_FLIGHT_REQUESTS: '/flights/get-flights-report',
        GET_FLIGHT_BY_FLIGHT_NUMBER: '/flights/get-flight-by-number',
        CANCEL_FLIGHTS: '/flights/cancel-flight',
    },
    DOCUMENTATION: {
        SWAGGER_V2_API: 'v2/api-docs',
    },
    HISTORY: {
        GET_FLIGHT_REQUESTS_HISTORIES: '/history/get-histories',
    },
    SYSTEM: {
        GET_RULES: '/config/get-rules',
        SET_RULES: '/config/set-rules'
    },
    REPORT: {
        CREATE: '/report/flight-request-report',
        PREVIEW: '/report/preview-request-report',
        REPORT_LIST: '/report/get-flight-request-reports',
        RPL_ARCHIVE_LIST: '/report/get-rpl-archive',
        DOWNLOAD_RPL: '/report/download-rpl-archive'
    },
    IAM: {
        GET_GROUPS_WITH_USER: "/iam/user-group/get-groups-with-users",
        GET_GROUPS: "/iam/user-group/get-groups",
        GET_USERS_WITH_GROUP: "/iam/user/get-users-with-groups",
        GET_USERS: "/users/get-users",
        GET_USERS_WITHOUT_PAGINATION: '/users/get-users-without-pagination',
        INSERT_OR_UPDATE_USER: '/iam/user/insert-or-update-user',
        DELETE_USER: '/iam/user/delete-user',
        //GET_GROUP_POLICIES: "/iam/user-group/get-group-policies",
        //GET_USER_WITH_GROUPS                : "/iam/user-group/get-user-with-groups",
        GET_POLICIES: "/iam/policies/get-policies",
        GET_FULL_POLICIES: "/iam/policies/get-full-policies",
        INSERT_OR_UPDATE_USER_GROUP: '/iam/user-group/insert-or-update-group',
        DELETE_USER_GROUP: '/iam/user-group/delete-group',
        INSERT_OR_UPDATE_POLICY: '/iam/policies/insert-or-update-policy',
        DELETE_POLICY: '/iam/policies/delete-policy',
    },
    TRANSLATION: {
        STATUS_TRANSLATION: '/translation/status-translation'
    }
};

export const PERMISSION_ACTIONS = {
    GET_SYSTEM_RULES: 'controllers.config.controller:getRules',
    SET_SYSTEM_RULES: 'controllers.config.controller:setRules',
    GET_SECURITY_PROFILE: 'controllers.user.controller:userProfile',
    UPDATE_SECURITY_PROFILE: "controllers.user.controller:updateUserProfile",
    DOWNLOAD_FLIGHT_REPORT: 'controllers.flights.controller:downloadFlights',
    GET_USER: 'controllers.users.controller:getCurrentUser',
    GET_PERMISSIONS: 'com.sena.cisWeb.user.SecurityController:getPermissions',
    GET_IAM_POLICIES: 'controllers.auth.controller:getIamPolicies',
    GET_LOGOUT: 'controllers.auth.controller:logout',
    GET_GET_USER_SECURITY_PROFILE: 'com.sena.cisWeb.user.SecurityController:getUserSecurityProfile',
    GENERATE_FLIGHT_REQUEST_REPORT: 'controllers.flights.controller:generateFlightRequestReport',
    GET_FLIGHT_REQUEST_REPORTS: 'controllers.flights.controller:getFlightRequestReports',
    REMOVE_FLIGHT_REQUESTS: 'controllers.flights.controller:removeFlightRequests',
    GET_RPL_LIST: 'controllers.report.controller:getRplArchive',
    GET_IAM_USERS: 'controllers.users.controller:getUsers'
};